import { cardClassName } from "@/lib/constants";

type ExperienceFailureStateProps = {
  actionLabel: string;
  description: string;
  detail?: string | null;
  onAction: () => void;
  title: string;
};

const ExperienceFailureState = ({ actionLabel, description, detail, onAction, title }: ExperienceFailureStateProps) => (
  <div className="flex h-full w-full items-center justify-center px-4 py-8">
    <div className={`${cardClassName} w-full max-w-md px-5 py-5`}>
      <p className="text-[10px] font-semibold uppercase tracking-[0.25em] text-amber-400">Runtime Fallback</p>
      <h2 className="mt-3 text-xl font-semibold text-zinc-100">{title}</h2>
      <p className="mt-2 text-sm leading-relaxed text-zinc-400">{description}</p>
      {detail && (
        <p className="mt-3 rounded-xl bg-zinc-900/70 px-3 py-2 font-mono text-[11px] text-zinc-500">{detail}</p>
      )}
      <button
        className="mt-4 cursor-pointer rounded-full border border-zinc-700 bg-zinc-900/90 px-4 py-2 text-sm font-medium text-zinc-100 transition-colors hover:border-emerald-500/40 hover:bg-zinc-800"
        onClick={onAction}
        type="button"
      >
        {actionLabel}
      </button>
    </div>
  </div>
);

export default ExperienceFailureState;
